import { render, staticRenderFns } from "./Areas_Pointer.vue?vue&type=template&id=5a7c9a24&"
import script from "./Areas_Pointer.vue?vue&type=script&lang=js&"
export * from "./Areas_Pointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports